module.exports = __webpack_public_path__ + "static/wages-41968c48d1165cd25f27404cb98b9093.png";